/* VIVID — home hero (sections/vh-video.liquid): the scroll cue.
   - Click, Enter or Space on the cue glides to whatever follows the hero (instantly when
     the shopper prefers reduced motion).
   - The cue fades once the page has scrolled ~40px past the hero's top, and comes back
     near the top. Its look and the dot's loop live in assets/vh-video.css.
   Play/pause of the video stays in vh.js (Splash Video module), which keeps its own
   cleanup on the section element; this file keeps its own in a WeakMap. */
(function () {
  if (window.VHHero) return;
  window.VHHero = true;

  const FADE_AFTER = 40;   // px scrolled before the cue fades
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const section = (sel, init, teardown) => (window.VH ? VH.section(sel, init, teardown) : document.querySelectorAll(sel).forEach(init));
  const live = new WeakMap();

  const init = (root) => {
    const cue = root.querySelector('[data-vh-cue]');
    if (!cue || live.has(root)) return;

    // The hero's bottom edge is where the next section starts (the reward popup in between
    // takes no room), and on phones it is also a snap stop.
    const onClick = () => {
      const top = root.getBoundingClientRect().bottom + window.scrollY;
      window.scrollTo({ top: Math.round(top), behavior: reduce.matches ? 'auto' : 'smooth' });
    };

    let scrolled = null;
    let frame = 0;
    const update = () => {
      frame = 0;
      const past = root.getBoundingClientRect().top < -FADE_AFTER;
      if (past === scrolled) return;
      scrolled = past;
      root.classList.toggle('is-scrolled', past);
    };
    const onScroll = () => { if (!frame) frame = requestAnimationFrame(update); };

    cue.addEventListener('click', onClick);
    window.addEventListener('scroll', onScroll, { passive: true });
    update();   // the browser may have restored a scrolled page

    live.set(root, () => {
      cue.removeEventListener('click', onClick);
      window.removeEventListener('scroll', onScroll);
      if (frame) cancelAnimationFrame(frame);
      root.classList.remove('is-scrolled');
    });
  };

  const teardown = (root) => {
    const off = live.get(root);
    if (!off) return;
    off();
    live.delete(root);
  };

  section('[data-vh-hero]', init, teardown);
})();
